import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import OperatingProceduresForm from "../../../../components/MainForm/OperatingProceduresForm";
import ItemStepMastersService from "../../../../services/itemstepmas.service";
import ItemStepDesService from "../../../../services/itemstepdes.service";

export default function AddOperatingProcedures() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  const handleSubmitMas = ({ Mas, Des }) => {
    setLoading(true);
    ItemStepMastersService.createItemStepMasters(Mas)
      .then((response) => {
        showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
        const itemStepDes = {
          Array: Des?.Array.map((item) => ({
            ...item,
            Item_Step_Id: response.generatedMaps[0].Id
          }))
        };
        handleSubmitDes(itemStepDes);
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmitDes = (data) => {
    setLoading(true);
    ItemStepDesService.createItemStepDescriptions(data)
      .then((_) => {
        showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
        navigate(0);
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Helmet>
        <title>เพิ่มขั้นตอนการปฏิบัติงาน</title>
        <meta name="description" content="Add Operating Procedures Page" />
      </Helmet>

      <Container fluid className="p-3">
        <OperatingProceduresForm onSubmitCallback={handleSubmitMas} />
      </Container>
    </>
  );
}
